import React from "react";
import { WitLabel } from "./common";

export function SectionLabel({ children = "" }: { children?: string }) {
  return <WitLabel>{children}</WitLabel>;
}
